import { render, staticRenderFns } from "./MovementDocumentForm.vue?vue&type=template&id=142a9d47&scoped=true&"
import script from "./MovementDocumentForm.vue?vue&type=script&lang=js&"
export * from "./MovementDocumentForm.vue?vue&type=script&lang=js&"
import style0 from "./MovementDocumentForm.vue?vue&type=style&index=0&id=142a9d47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142a9d47",
  null
  
)

export default component.exports